import { styled } from "styled-components";
import { borderRadius, rgba } from "polished";
const TabAddButtonImpl = styled("button").attrs({
  type: "button"
})(({ theme }) => ({
  backgroundColor: theme.color.monochrome2,
  borderColor: theme.borderColor,
  ...borderRadius("top", 2),
  borderStyle: "solid",
  borderWidth: "1px 1px 0",
  boxSizing: "content-box",
  color: theme.color.default,
  cursor: "pointer",
  fontFamily: theme.fontFamily.default,
  fontSize: 16,
  fontWeight: theme.fontWeight.normal,
  lineHeight: 1,
  outline: 0,
  padding: "7px 11px 8px",
  width: 16,
  "&:hover": {
    backgroundColor: theme.color.monochrome3
  },
  "&:active": {
    backgroundColor: theme.color.monochrome4
  },
  "&:focus": {
    boxShadow: `0 0 0 2px ${rgba("black", 0.05)}`
  }
}));
export {
  TabAddButtonImpl
};
